export default __webpack_public_path__ + "static/media/03.997a9ba6.png";